<template>
  <div class="page">
    <app-loader v-if="loader" />
    <template v-else>
      <scanner
        ref="scanner"
        page-title="Перемещение"
        title="VIN-номер"
        @input="checkVin"
      />
      <div
        v-if="car.vin"
        class="page__wrapper"
      >
        <v-card
          elevation="1"
          color="success lighten-5"
          class="mb-5"
        >
          <v-card-text>
            {{ car.vin }}
            <div class="text-transform-none">
              {{ car.model }}, {{ car.color }} <br>
              Место: {{ car.location.storageDescription }}, {{ car.location.siteDescription }}
            </div>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <div
      v-if="!isScannerShown"
      class="page__actions"
    >
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.go(-1)"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        v-if="car.vin && !noLocation && !acceptLoader"
        class="ml-auto"
        color="success"
        x-large
        @click="confirmationModal = true"
      >
        В работу
      </v-btn>
    </div>
    <result-modal
      v-model="resultModal"
      :title="resultModalTitle"
      :text="car.vin"
      success
      @close="goToNavigation"
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptVin"
    />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';
import { cloneDeep } from 'lodash-es';
import { mapState } from 'vuex';

export default {
  name: 'Moving',
  components: {
    Scanner,
    ConfirmationModal,
    ResultModal,
  },
  props: {
    vin: String,
  },
  data: () => ({
    loader: false,
    acceptLoader: false,
    resultModal: false,
    confirmationModal: false,
    inWork: false,
    noLocation: false,
    error: false,
    scannedVin: null,
    car: {},
    errorModal: false,
    errorText: '',
  }),
  computed: {
    ...mapState(['isScannerShown']),
    resultModalTitle() {
      const errorMessage = this.error?.response?.data?.Error?.message;

      if (errorMessage) {
        return errorMessage;
      }

      if (this.vin && !this.VinNumbersEqual) {
        return `Отсканированный VIN-номер (${this.scannedVin}) не совпадает с выбранным номером в заявке (${this.vin})`;
      }

      if (this.inWork) {
        return 'Заказ в работе';
      }

      if (this.noLocation) {
        return 'Данный автомобиль невозможно взять в работу';
      }

      return this.car.vin ? 'VIN найден' : 'Ошибка';
    },
    VinNumbersEqual() {
      return this.scannedVin && this.vin === this.scannedVin;
    },
  },
  watch: {
    resultModal(val) {
      if (!val) {
        this.stopScanning();
      }
    },
  },

  created() {
    this.getCarByUser();
  },
  methods: {
    async getCarByUser() {
      this.loader = true;
      try {
        const { data: vin } = await this.$http.get('MobileOperatorInterface/BasicOperations/CarByUser');

        if (vin) {
          this.$router.push(`/moving-car-in-work/${vin}`);
        }
      } finally {
        this.loader = false;
      }
    },
    async getCarInfo(vin) {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${vin}`);
      return Promise.resolve(data);
    },
    checkVin(vin) {
      this.error = false;
      this.inWork = false;
      this.noLocation = false;
      this.car = {};

      this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${vin}`)
        .then(({ data }) => {
          this.scannedVin = data.vin;
          if (this.vin && !this.VinNumbersEqual) {
            return;
          }

          if (data.status === 'ЗаказВРаботе') {
            this.inWork = true;
            return;
          }

          if (!data.location.storageId) {
            this.noLocation = true;
          }

          this.car = data;
        }).catch((e) => {
          this.error = e;
        }).finally(() => {
          this.resultModal = true;
        });
    },
    async acceptVin() {
      this.error = false;
      this.acceptLoader = true;
      const params = cloneDeep(this.car);

      params.status = 'ЗаказВРаботе';
      params.operation = 'СвободноеПеремещение';

      if (this.vin) {
        params.operation = 'ПеремещениеНаОтгрузку';
      }

      await this.$http.post(`MobileOperatorInterface/BasicOperations/Car/${this.car.vin}`, params)
        .then(() => {
          this.inWork = true;
          this.resultModal = true;
          this.car = {};
        }).catch((e) => {
          this.onErrorHandler(e);
        }).finally(() => {
          this.acceptLoader = false;
        });
    },
    stopScanning() {
      this.$refs.scanner.stopScanning();
    },
    onInput(vin) {
      this.checkVin(vin);
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
    goToNavigation() {
      if (this.inWork) {
        this.$router.push('/navigation');
      }
    },
  },
};
</script>
